import { createFileRoute } from "@tanstack/react-router";

import { OrgAppSettingPage } from "./-components/OrgAppSettingPage";

export const Route = createFileRoute("/_staff/software/_layout/settings/")({
  component: OrgAppSettingPage,
});
